import React from "react";
import { HexColorPicker, HexColorInput, RgbaStringColorPicker } from "react-colorful";
import { ReactComponent as ColorPickerIcon } from '../../svg/color-picker-icon.svg'
import { inject, observer } from 'mobx-react';

@inject('templateStore', 'workAreaStore', 'sidebarStore') @observer
class ColorPicker extends React.Component {

    constructor(props){
      super(props)
      this.state = {
        cursorPicker: false
      }
      this._fillTimer = null
    }

    componentDidUpdate = () => {
      const { workAreaStore, isSidebar } = this.props
      if (!workAreaStore.selectedLayer && !workAreaStore.activePage && !isSidebar) {
        this.props.sidebarStore.closeSidebarSlide()
      }
    }

    componentWillUnmount(){
      clearTimeout(this._fillTimer)
    }

    toggleCursorPicker(){
      this.props.workAreaStore.setCursorPicker(!this.props.workAreaStore.cursorPicker)
    }
    
    onChange = color => {
      const { workAreaStore, isSidebar } = this.props
      if (workAreaStore.selectedLayer && !isSidebar) {
        const { pageIdx, layerIdx } = workAreaStore.findLayerIdx(workAreaStore.selectedLayer)
        if(pageIdx > -1 && layerIdx > -1){
          const layer = workAreaStore.pages[pageIdx].layers[layerIdx]
          if(layer && !this.timer && layer.type === 'svgGroup'){
            clearTimeout(this._fillTimer)
            this._fillTimer = setTimeout(() => {
              workAreaStore.changeSVGGroupFill(layer.id, color)
              return
            }, 200)
            return
          }
          if (layer && !this.timer && (layer.type === 'element' || layer.type === 'svg')) {
            workAreaStore.changeLayerProp(layer.id, 'fillHex', color)
          }
          return
        }else{
          return
        }
      }
      if(workAreaStore.activePage || (workAreaStore.activePage && isSidebar)) {
        const page = workAreaStore.getPage(workAreaStore.activePage)
        if(page){
          page.background = color
        }
      }
      if(isSidebar && !workAreaStore.activePage){
        workAreaStore.changePagesColor(color)
      }
    }

    onInputChange = color => {
      if(color.length >= 7){
        const val = this.props.workAreaStore.hexToRgba(color)
        this.onChange(val)
      }
    }

    convertHex(value, input){
      if(!value){
        return value
      }
      const isRgba = value.includes('rgba')
      if(!isRgba && !input){
        return this.props.workAreaStore.hexToRgba(value)
      }
      if(input && isRgba){
        return this.props.workAreaStore.rgbToHex(value)
      }
      return value
    }

    getColor = input => {
      const { workAreaStore, isSidebar } = this.props
      if (workAreaStore.selectedLayer && !isSidebar) {
        const layer = workAreaStore.getLayer(workAreaStore.selectedLayer)
        if(layer && layer.type !== 'element' && layer.type !== 'svg' && layer.type !== 'svgGroup'){
          this.props.sidebarStore.closeSidebarSlide()
          return
        }
        if(layer.type === 'svgGroup' && workAreaStore.editingColor){
          return this.convertHex(workAreaStore.editingColor, input)
        }
        if (layer) {
          return this.convertHex(layer.fillHex, input)
        }
      }
      if(workAreaStore.activePage) {
        const page = workAreaStore.getPage(workAreaStore.activePage)
        if(page){
          const isRgba = page.background.includes('rgba')
          if(!isRgba && !input){
            return this.props.workAreaStore.hexToRgba(page.background)
          }
          if(input && isRgba){
            return this.props.workAreaStore.rgbToHex(page.background)
          }
          return page.background
        }
      }
      if(!workAreaStore.activePage && isSidebar){
        const page = workAreaStore.pages[0]
        const isRgba = page.background.includes('rgba')
        if(!isRgba && !input){
          return this.props.workAreaStore.hexToRgba(page.background)
        }
        if(isRgba && input){
          return this.props.workAreaStore.rgbToHex(page.background)
        }
        return page.background
      }
    }

    getTransparentCheck(){
      const { showTransparent, pageId, transparent } = this.props
      if(showTransparent){
        return (
          <div className='react-colorful__transparent-wrapper'>
            <input 
              type='checkbox'
              className='form-control cursor-pointer'
              onChange={() => this.props.setTransparent()}
              checked={transparent}
            />
            <label
              onClick={() => this.props.setTransparent()}
              className='gray cursor-pointer'
            >
              Transparent background
            </label>
          </div>
        )
      }
      return (
        <div />
      )
    }

    render() {
      const { isText, showTransparent, workAreaStore } = this.props
      const className = showTransparent ? `form-control transparent-enabled` : 'form-control'
      const c = this.getColor(true)
      return (
        <div className="col-12">
          <div className="">
            <RgbaStringColorPicker
              color={this.getColor()}
              onChange={this.onChange}
            />
            <div className='react-colorful__input-wrapper'>
              <HexColorInput
                className={className}
                alpha
                color={c}
                onChange={color => this.onInputChange(color)}
              />
              {this.getTransparentCheck()}
            </div>
          </div>
        </div>
      );
    }
}

/*
              <ColorPickerIcon 
                className={`react-colorful__cursor-picker${showTransparent ? ' transparent' : ''}`}
                stroke={workAreaStore.cursorPicker ? '#3767f6' : '#212121'}
                onClick={() => this.toggleCursorPicker()}
              />
*/

export default ColorPicker;
